module.exports = __webpack_public_path__ + "img/bj_jindu_1@2x.78362aaf.png";